//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import { ucWebPath } from '@/config/project-config'
import { Toast } from 'vant'

export default {
  name: 'login',
  components: {
    Header,Footer
  },
  data() {
    return {
      userPhone: '', // 手机号
      password: '', // 验证码
      second: 59, // 倒计时数字
      timeFlag: false, // 验证码开关，
      state: this.$route.query.state,//跳转页面的时候，带的参数
      redirect_uri: this.$route.query.redirect_uri ,//要跳转的其他系统的地址
      inType:this.$route.query.inType,//只有内部系统跳转的时候，这个值才有  传1
      isSamll: 0
    };
  },
  created () {
    if (window.screen.height <= 768 && window.screen.width <= 1366) {
      this.isSamll = 1
    }
  },
  methods: {
    fnSendSms() { // 发送验证码
      if(this.userPhone == ''){
        Toast('请输入手机号')
        return
      }
      let param = {
          smsType: 0,
          smsPhone: this.userPhone
      }
      let checkParam = {
        userPhone: this.userPhone,
      };
      this.$store
        .dispatch("user/checkLoginPhoneHave", JSON.stringify(checkParam))
        .then((res) => {
          if (res.data.retCode == 1) {
            // 调用发验证码接口
            this.$store.dispatch('fnNoCheckSmsSendSmsCode',JSON.stringify(param)).then(res=>{
              console.log('---------',res);
              if(res.data.retCode == 1){
                this.fnHandleTimer()
              }else{
                Toast(res.data.retMsg)
              }
            })
          } else {
            Toast(res.data.retMsg);
          }
        });
    },
    fnHandleTimer() { // 处理验证码
      let maxSecond = 60
      this.timeFlag = true
      let timer = setInterval(() => {
       if (this.second > 0 && this.second <= maxSecond) {
         this.second--
        } else {
         this.timeFlag = false
         this.second = 59
         clearInterval(timer)
        }
       }, 1000)
    },
    fnGoToRegistePage() { // 跳转到注册
      this.$router.push({ path: 'registe' })
    },
    fnGoToLoginPage(type) { // 跳转到微信登录
      this.$router.push({path:"wxScan"})
    },
    fnConfirm() { // 提交
      if(this.fnCheckForm()){
        let param = {
          loginType: 0,
          userPhone: this.userPhone,
          password: this.password
        }
        this.$store.dispatch('user/fnLoginNoCheckDoLogin',JSON.stringify(param)).then(res=>{
          if(res.data.retCode == 1){
            Toast('登录成功')
            this.fnHandleUser(res.data.obj)
          }else{
            Toast(res.data.retMsg)
          }
        })
      }
    },
    fnCheckForm() { // 验证表单
      if(this.userPhone == ''){
        Toast('请输入手机号')
        return false
      }
      if(this.password == ''){
        Toast('请输入验证码')
        return false
      }
      return true
    },
    fnHandleUser(obj) { // 处理登录后用户信息
      // 保存到token中
      this.$nextTick(()=>{
        localStorage.setItem('alreadyLogin', 'alreadyLogin' + new Date().getTime() + '')
      })
      this.$store.commit('setUserInfo',obj)
      if(this.inType == 1){//AI智能报价
         this.$router.push({path: this.redirect_uri,  params: {'schemeInfo': this.state}});
      }else if(this.inType == 2 || this.inType == 3){//从 企业主页 点击“关注企业”登录后跳回 企业主页
         this.$router.push({path: this.redirect_uri,  query: {'companyId': this.state,'optType': this.inType}});
      }else{
        // 跳转到平台首页
        let redirect = localStorage.getItem('fromPage')
        if (redirect && redirect != '/wxLoginBackRegister') {
          let fromPageQuery = localStorage.getItem('fromPageQuery')
          this.$router.push({path:redirect,query:JSON.parse(fromPageQuery)})
        } else {
          this.$router.push({path: '/'})
        }
        // this.$router.push({path: '/'})
        // if(window.opener!=null){
        //   window.opener.location.reload()//刷新父页面
        // }
        // 跳转到用户中心
        // this.fnGotoUserCenter({
        //   self_redirect: '1',
        //   state:this.state,
        //   second_redirect_uri:this.redirect_uri,
        //   sucessCallBack: function () {
        //     if(window.opener!=null){
        //       window.opener.location.reload()//刷新父页面
        //     }
        //   }
        // })
      }
    },



  }
};



// WEBPACK FOOTER //
// ./src/pages/login/login.vue